import {
  action, flow, makeObservable, observable,
} from 'mobx';
import ReviewsAPI from '../api/reviews';
import BaseStore from './BaseStore';

class ReviewsStore extends BaseStore {
  isSending = false;
  isLoading = false;
  reportResult = null;
  reportReasons = [];
  answers = {};

  getReasons = flow(function* (isSchool) {
    this.isLoading = true;

    try {
      const { data } = isSchool ? yield ReviewsAPI.getReasons() : yield ReviewsAPI.getExamCenterReasons();
      this.reportReasons = data;
    } catch (errors) {
      // eslint-disable-next-line no-console
      console.error(errors.response.data.errorMessages);
    } finally {
      this.isLoading = false;
    }
  });

  report = flow(function* (payload, callbackObj, isSchool) {
    const { setErrors } = callbackObj;

    this.isSending = true;
    try {
      if (isSchool) {
        yield ReviewsAPI.sendReport({ review_report: payload });
      } else {
        yield ReviewsAPI.sendExamCenterReport({ exam_center_review_report: payload });
      }
      this.reportResult = true;
    } catch (errors) {
      setErrors(errors.response.data.errorMessages);
      this.reportResult = false;
    } finally {
      this.isSending = false;
    }
  });

  answer = flow(function* (payload, callbackObj, isSchool = true) {
    const { setErrors } = callbackObj;

    this.isSending = true;
    try {
      const { data } = isSchool ? yield ReviewsAPI.sendAnswer(payload) : yield ReviewsAPI.sendExamCenterAnswer(payload);
      this.answers[payload.id] = data.answer;
    } catch (errors) {
      setErrors(errors.response.data.errorMessages);
    } finally {
      this.isSending = false;
    }
  });

  constructor() {
    super();

    makeObservable(this, {
      isSending: observable,
      isLoading: observable,
      reportResult: observable,
      reportReasons: observable,
      answers: observable,
      setAnswer: action.bound,
    });
  }

  setAnswer(id, text) {
    this.answers[id] = text;
  }
}

export default new ReviewsStore();
